/* src/app/features/prestacao-informacoes/acompanhamento-processual/acompanhamento-processual-listagem.component.scss */
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=acompanhamento-processual-listagem.component.css.map */
